import { BackgroundColor } from '@/theme/types';
import { Button } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { Sheet, SheetContent, SheetTrigger } from '@/shadcn-ui/sheet';
import Hamburger from '@/icons/hamburger';
import HeaderNavigationMenu, {
  HeaderNavigationMenuProps,
} from './header-navigation-menu';
import HeaderViewCarsButton from './header-view-cars-button';

export interface HeaderSheetProps
  extends Omit<HeaderNavigationMenuProps, 'direction' | 'className'> {
  className?: string;
  backgroundColor?: BackgroundColor;
  hamburgerFillPrimary?: string;
}

export default function HeaderSheet({
  isLoggedIn,
  dark = false,
  className,
  hideHomeLink = false,
  hideCatalogLink = false,
  whyFlexcarButtonOnClickDelegate,
  backgroundColor,
  hamburgerFillPrimary,
}: HeaderSheetProps) {
  const hamburgerColor =
    hamburgerFillPrimary ?? (dark ? colors.neutral100 : colors.blue30);
  return (
    <div className="flex flex-row justify-end gap-[16px]">
      {hideCatalogLink !== true ? (
        <HeaderViewCarsButton
          dark={dark}
          className={cn('transition-opacity sm:hidden', {
            'sm:opacity-1 opacity-0': hideCatalogLink === 'mobile',
            className,
          })}
        />
      ) : null}

      <Sheet>
        <SheetTrigger asChild className={cn('h-auto', className)}>
          <Button variant="clear">
            <Hamburger color={hamburgerColor} />
          </Button>
        </SheetTrigger>

        <SheetContent
          dark={dark}
          className={cn(
            className,
            {
              'border-flexcar-neutral5 bg-flexcar-neutral1': dark,
            },
            backgroundColor
          )}
          overlayClassName={className}
        >
          <HeaderNavigationMenu
            isLoggedIn={isLoggedIn}
            dark={dark}
            hideCatalogLink={hideCatalogLink}
            hideHomeLink={hideHomeLink}
            whyFlexcarButtonOnClickDelegate={whyFlexcarButtonOnClickDelegate}
            direction="vertical"
          />
        </SheetContent>
      </Sheet>
    </div>
  );
}
